module.exports = __webpack_public_path__ + "static/logo-light-e72456212cbef178ec082238fe73f758.jpg";